"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
var QwilrGrayscale = function QwilrGrayscale(props) {
  var _a = props,
    className = _a.className,
    _a$size = _a.size,
    size = _a$size === void 0 ? IconSize.Medium : _a$size,
    _a$color = _a.color,
    color = _a$color === void 0 ? "inherit" : _a$color,
    rest = __objRest(_a, ["className", "size", "color"]);
  var iconClass = classNames(styles.icon({
    size: size,
    color: color
  }), "kl-icon", "kl-icon--".concat(size), className);
  return React.createElement("svg", __spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    className: iconClass
  }, rest), /* @__PURE__ */React.createElement("path", {
    d: "M12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24Z",
    fill: "white"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M12 23.5C18.3513 23.5 23.5 18.3513 23.5 12C23.5 5.64873 18.3513 0.5 12 0.5C5.64873 0.5 0.5 5.64873 0.5 12C0.5 18.3513 5.64873 23.5 12 23.5Z",
    fill: "white",
    stroke: "#8790A6"
  }), /* @__PURE__ */React.createElement("path", {
    opacity: 0.5,
    d: "M6.48998 15.003L7.87998 17.121C7.93592 17.2039 8.01136 17.2718 8.09967 17.3188C8.18798 17.3657 8.28647 17.3903 8.38648 17.3903C8.4865 17.3903 8.58499 17.3657 8.6733 17.3188C8.76161 17.2718 8.83704 17.2039 8.89298 17.121L11.998 12.201L9.68998 8.535L6.46998 13.778C6.35589 13.9628 6.29714 14.1763 6.30069 14.3934C6.30423 14.6105 6.36992 14.8221 6.48998 15.003Z",
    fill: "#8790A6"
  }), /* @__PURE__ */React.createElement("path", {
    opacity: 0.7,
    d: "M17.53 13.778L14.31 8.534L11.998 12.208L15.107 17.128C15.1628 17.2111 15.2382 17.2792 15.3265 17.3263C15.4148 17.3734 15.5134 17.3981 15.6135 17.3981C15.7136 17.3981 15.8122 17.3734 15.9005 17.3263C15.9888 17.2792 16.0642 17.2111 16.12 17.128L17.51 15.008C17.6297 14.826 17.6951 14.6137 17.6986 14.3959C17.7022 14.1781 17.6437 13.9638 17.53 13.778Z",
    fill: "#8790A6"
  }), /* @__PURE__ */React.createElement("path", {
    d: "M13.427 7.09299L12.508 5.67499C12.4524 5.59124 12.3768 5.52256 12.2882 5.47505C12.1996 5.42754 12.1006 5.40268 12 5.40268C11.8995 5.40268 11.8005 5.42754 11.7118 5.47505C11.6232 5.52256 11.5477 5.59124 11.492 5.67499L10.573 7.09499L9.68903 8.53499L11.999 12.208L14.31 8.54999L13.426 7.09299H13.427Z",
    fill: "#8790A6"
  }));
};
export default QwilrGrayscale;